import axios from 'axios';

export default function sendContact(partnershipId, data) {
  return axios.post(`/api/v1/partnership/${partnershipId}/_contact`, data);
}
